module.exports = __webpack_public_path__ + "static/img/30.0fbf891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/30.jpg
// module id = yl1Q
// module chunks = 0